<div class="flex percentage-container items-center">
  <h1 style="margin-bottom: 0;">{{title}}</h1>
  <div class="percentage accent-bg" [ngClass]="{'disabled': praticaProgressService.isFrozen}"> {{percentage}} </div>
</div>
